import $ from 'jquery';

function updateReceiverStateWording(country) {
  // Desktop and mobile can contain separate copies of the same form fields.
  const section = $(country).closest('.sending_section');
  if (!section.length) return;

  const isThailand = String($(country).val() || '').trim().toLowerCase() === 'thailand';
  section.find('.js-receiver-state-label').each(function() {
    $(this).text(isThailand ? this.dataset.provinceLabel : this.dataset.stateLabel);
  });
  section.find('input[data-state-placeholder]').each(function() {
    this.placeholder = isThailand ? this.dataset.provincePlaceholder : this.dataset.statePlaceholder;
  });
}

$(document).on('change', 'select[name$="[receiver_country]"]', function() {
  updateReceiverStateWording(this);
});

$(document).on('turbolinks:load shown.bs.modal ajaxComplete', function() {
  $('select[name$="[receiver_country]"]').each(function() {
    updateReceiverStateWording(this);
  });
});
